import * as React from "react";
import type { SVGProps } from "react";
const SvgXSquareContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M15.394 8.606 12 12m0 0-3.394 3.394M12 12l3.394 3.394M12 12 8.606 8.606M21.6 6v12a3.6 3.6 0 0 1-3.6 3.6H6A3.6 3.6 0 0 1 2.4 18V6A3.6 3.6 0 0 1 6 2.4h12A3.6 3.6 0 0 1 21.6 6Z"
    />
  </svg>
);
export default SvgXSquareContained;
